(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/constants.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/constants.js');

'use strict';

svs.playerLogin.constants.loginType = {
  BANKID: 'bankid',
  FREJAEID: 'frejaeid'
};
svs.playerLogin.constants.route = {
  LOGIN_HOME_ROUTE: '/',
  REGISTRATE_HOME_ROUTE: '/registrering',
  LOGIN_BANKID_ROUTE: '/inloggning/bankid',
  REGISTRATE_BANKID_ROUTE: '/registrering/bankid',
  LOGIN_BANKID_START_ROUTE: '/inloggning/bankid/start',
  LOGIN_BANKID_POLL_QR_ROUTE: '/inloggning/bankid/qr',
  LOGIN_BANKID_POLL_APP_ROUTE: '/inloggning/bankid/app',
  REGISTRATE_BANKID_START_ROUTE: '/registrering/bankid/start',
  REGISTRATE_BANKID_POLL_QR_ROUTE: '/registrering/bankid/qr',
  REGISTRATE_BANKID_POLL_APP_ROUTE: '/registrering/bankid/app',
  LOGIN_FREJAEID_ROUTE: '/inloggning/frejaeid',
  REGISTRATE_FREJAEID_ROUTE: '/registrering/frejaeid',
  LOGIN_FREJAEID_START_ROUTE: '/inloggning/frejaeid/start',
  LOGIN_FREJAEID_POLL_QR_ROUTE: '/inloggning/frejaeid/qr',
  LOGIN_FREJAEID_POLL_APP_ROUTE: '/inloggning/frejaeid/app',
  REGISTRATE_FREJAEID_POLL_ROUTE: '/registrering/frejaeid/start',
  REGISTRATE_FREJAEID_POLL_QR_ROUTE: '/registrering/frejaeid/qr',
  REGISTRATE_FREJAEID_POLL_APP_ROUTE: '/registrering/frejaeid/app'
};

svs.playerLogin.constants.bankidProgressStatus = {
  ERROR_POLL: -1,
  BEFORE_POLL: 0,
  SHOWING_QRCODE: 1,
  WAITING_SSNAPP: 1,
  WAITING_APP: 1,
  WAITING_CLIENT: 2,
  SHOWING_SPINNER: 4,
  ONLINE_CUSTOMER: 6,
  NEW_CUSTOMER: 20,
  RETAIL_CUSTOMER: 21
};
svs.playerLogin.constants.frejaeIdProgressStatus = {
  ERROR_POLL: -1,
  BEFORE_POLL: 0,
  WAITING_APP: 1,
  SHOWING_QRCODE: 1,
  SHOWING_SPINNER: 2,
  USER_DECLINED: 3,
  SVS_DECLINED: 4,
  CLIENT_TIMEOUT: 5,
  ONLINE_CUSTOMER: 6,
  DUPLICATED_AUTHTOKEN: 7,
  NEW_CUSTOMER: 20,
  RETAIL_CUSTOMER: 21
};


svs.playerLogin.constants.frejaeIdLevel = {
  NONE: 0,
  EXTENDED: 1,
  PLUS: 2
};

svs.playerLogin.constants.appWaitStatus = {
  NO_WAIT: 'nowait',
  WAITING_QRCODE: 'qrcode',
  WAITING_SSNAPP: 'ssnapp',
  WAITING_APP: 'app',
  WAITING_CUSTOMER: 'customer'
};
svs.playerLogin.constants.bankIdPollType = {
  BEFORE_POLL: 'beforepoll',
  SSN_INPUT: 'ssninput',
  WAITING_POLL: 'waitingpoll',
  SPINNER_POLL: 'spinnerpoll'
};
svs.playerLogin.constants.frejaeIdPollType = {
  BEFORE_POLL: 'beforepoll',
  WAITING_POLL: 'waitingpoll',
  SSN_INPUT: 'ssninput',
  SAME_DEVICE_POLL: 'samedevicepoll',
  SPINNER_POLL: 'spinnerpoll'
};

 })(window);